import api from "../api";

export const customBaseQuery = async (args: {
  url: string;
  method?: string;
  body?: any;
  params?: any;
}) => {
  const { url, method = "GET", body, params } = args;

  try {
    const result = await api({
      url,
      method,
      data: body,
      params,
    });
    return { data: result.data };
  } catch (error: any) {
    return {
      error: {
        status: error.response?.status || 500,
        data: error.response?.data || error.message,
      },
    };
  }
};
